import React from 'react';

type Props = {
  children: React.JSX.Element;
  className?: string;
  name?: string;
  style?: { [key: string]: string };
};

// This component is only here to add in the data-test
const DayColumn = (
  { className, name, style, children }: Props,
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  return (
    <div
      className={className}
      style={style}
      ref={ref}
      data-test={name || 'DAY_COLUMN'}
    >
      {children}
    </div>
  );
};

export const CalendarDayColumn = React.forwardRef<HTMLDivElement, Props>(
  DayColumn
);
